import { Fragment, useRef } from "react";
import styles from "./InquiryForm.module.css";

export default function PhoneNumberInput({ value, onChange, required, error }) {
  const inputs = useRef([]);
  const digits = value.padEnd(10, " ").slice(0, 10).split("");

  const focusDigit = (index) => {
    inputs.current[index]?.focus();
    inputs.current[index]?.select();
  };

  const updateDigits = (index, text) => {
    let incoming = text.replace(/\D/g, "");
    if (incoming.length === 11 && incoming.startsWith("1")) {
      incoming = incoming.slice(1);
    }
    if (!incoming) return;
    const start = incoming.length >= 10 ? 0 : index;
    const next = [...digits];
    incoming.slice(0, 10 - start).split("").forEach((digit, offset) => {
      next[start + offset] = digit;
    });
    onChange(next.join(""));
    focusDigit(Math.min(start + incoming.length, 9));
  };

  return (
    <fieldset>
      <legend>Phone Number {required && "*"}</legend>
      <div className={styles.phoneDigits}>
        <span className={styles.phoneSeparator} aria-hidden="true">(</span>
        {digits.map((digit, index) => (
          <Fragment key={index}>
          <input
            ref={(element) => { inputs.current[index] = element; }}
            className={styles.phoneDigit}
            type="tel"
            inputMode="numeric"
            autoComplete={index === 0 ? "tel-national" : "off"}
            aria-label={`Phone number digit ${index + 1} of 10`}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? "phoneNumber-error" : undefined}
            value={digit.trim()}
            placeholder="0"
            pattern="[0-9]"
            required={required}
            onFocus={(event) => event.target.select()}
            onChange={(event) => {
              if (!event.target.value) {
                const next = [...digits];
                next[index] = " ";
                onChange(next.join(""));
              } else {
                updateDigits(index, event.target.value);
              }
            }}
            onPaste={(event) => {
              event.preventDefault();
              updateDigits(index, event.clipboardData.getData("text"));
            }}
            onKeyDown={(event) => {
              if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                event.preventDefault();
                focusDigit(Math.max(0, Math.min(9, index + (event.key === "ArrowLeft" ? -1 : 1))));
              }
              if (event.key === "Backspace") {
                event.preventDefault();
                const target = digit.trim() ? index : Math.max(0, index - 1);
                const next = [...digits];
                next[target] = " ";
                onChange(next.join(""));
                focusDigit(target);
              }
            }}
          />
          {index === 2 && (
            <span className={styles.phoneSeparator} aria-hidden="true">)</span>
          )}
          {index === 5 && (
            <span className={styles.phoneSeparator} aria-hidden="true">-</span>
          )}
          </Fragment>
        ))}
      </div>
      {error && <p id="phoneNumber-error" className={styles.error}>{error}</p>}
    </fieldset>
  );
}
